import React, { useEffect, useRef } from 'react';
import CtaLink from 'components/essentials/Cta/CtaLink';

const OrderIssueSuccess = () => {
  const successWrapperRef = useRef(null);

  useEffect(() => {
    successWrapperRef.current?.scrollIntoView({
      block: 'center',
      inline: 'center',
    });
  }, []);

  return (
    <div className="text-gray" ref={successWrapperRef}>
      <h1 className="mb-6 text-2xl font-bold">We’ve received your request!</h1>

      <p className="mb-6 text-sm">
        A sincere thank you for taking the time to complete the details of what
        went wrong, it will help us serve you and ensure we get your issue
        resolved as quick as possible.
      </p>

      <p className="mb-6 text-sm">
        A representative will follow up with you shortly to discuss next steps.
      </p>

      <CtaLink to="/" block styling="solid-button" color="brand">
        Back to home page
      </CtaLink>
    </div>
  );
};

export default OrderIssueSuccess;
